import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { any, propEq } from "ramda";
import { isBlank } from "../util/ext";

export const creatorRoles = [
  "ROLE_ADMIN",
  "ROLE_CONTENT_MANAGER",
  "ROLE_CREATOR_USER",
  "ROLE_CREATOR_MANAGER",
];

export const hasAdminRole = user => {
  return hasRole(user, "ROLE_ADMIN");
};

export const hasCreatorManagerRole = org => {
  return hasRole(org, "ROLE_CREATOR_MANAGER");
};

export const hasIAPManagerRole = org => {
  return hasRole(org, "ROLE_IAP_MANAGER");
};

export const isUserAuthor = user => {
  return any(propEq("roleName", "ROLE_AUTHOR"), user.roles);
};

export const isUserIAPManager = user => {
  return hasRole(user, "ROLE_IAP_MANAGER");
};

export const useIsUserIAPManager = () => {
  const auth = useSelector(state => state.auth);
  const [hasIAPRole, setHasIAPRole] = useState(false);
  useEffect(() => {
    //-- The role should be on the org not the user, keeping the user check for backwards compatability.
    const isIAP =
      isUserIAPManager(auth.user) ||
      hasIAPManagerRole(auth.currentOrganization);
    setHasIAPRole(isIAP);
  }, [auth]);
  return hasIAPRole;
};

export const useCurrentUser = () => {
  return useSelector(state => state.auth.user);
};

export const hasCreatorRole = org => hasAnyRole(org, creatorRoles);

export const hasRole = (principal, role) => {
  return (
    principal &&
    principal.roles &&
    any(prole => prole === role, principal.roles)
  );
};

export const hasAnyRole = (principal, roles) => {
  return any(role => hasRole(principal, role), roles);
};

export const hasOrgRoleRole = (organizations, role) => {
  return any(org => hasRole(org, role), organizations);
};

export const useIsAdmin = () => {
  const auth = useSelector(state => state.auth);

  return isBlank(auth.currentOrganization);
};

export const useIsCreatorManager = () => {
  const auth = useSelector(state => state.auth);
  return hasCreatorManagerRole(auth.currentOrganization);
};

export const useCurrentOrgId = () => {
  return useSelector(state =>
    state.auth.currentOrganization
      ? state.auth.currentOrganization.id
      : "admin",
  );
};
